import type { ReactNode } from 'react';
import styles from '@/styles/components/AppHeader.module.css';

interface AppHeaderProps {
  title?: string;
  tagline?: string;
  onSettingsClick?: () => void;
  right?: ReactNode;
}

export function AppHeader({ title = 'Yeastus Crust', tagline = 'Crust has risen', onSettingsClick, right }: AppHeaderProps) {
  return (
    <header className={styles.header}>
      <div>
        <h1 className={styles.appName}>{title}</h1>
        {tagline && <p className={styles.tagline}>{tagline}</p>}
      </div>
      <div className={styles.headerActions}>
        {right}
        {onSettingsClick && (
          <button
            className={styles.settingsButton}
            onClick={onSettingsClick}
            aria-label="Settings"
          >
            ⚙
          </button>
        )}
      </div>
    </header>
  );
}
